import { connect } from "react-redux";
import { Creators } from "../../../reducer";
import Profile from "./Profile";

export default connect(null, dispatch => ({
  onSave: customer => dispatch(Creators.saveCustomer(customer))
}))(Profile);



// WEBPACK FOOTER //
// ./src/customer/components/EditCustomer/Profile/index.js